/**
 * Load optional features only when their markup exists. Observe inserted subtrees
 * too: quick-add, cart updates and the theme editor can introduce them later.
 * Critical commerce/gallery modules remain in the initial script bundle.
 */
const modules = new Map([
  ['product-title', '@theme/product-title'],
  ['rte-formatter', '@theme/rte-formatter'],
  ['show-more-component', '@theme/show-more'],
  ['anchored-popover-component', '@theme/anchored-popover'],
  ['floating-panel-component', '@theme/floating-panel'],
  ['layered-slideshow-component', '@theme/layered-slideshow'],
  ['video-background-component', '@theme/video-background'],
  ['volume-pricing', '@theme/volume-pricing'],
  ['price-per-item', '@theme/price-per-item'],
  ['volume-pricing-info', '@theme/volume-pricing-info'],
]);
const selector = [...modules.keys()].join(',');
const requested = new Set();

function load(element) {
  const name = element.localName;
  if (!modules.has(name) || requested.has(name) || customElements.get(name)) return;
  requested.add(name);
  import(modules.get(name)).catch((error) => {
    requested.delete(name);
    console.error(`Unable to load optional component: ${name}`, error);
  });
}

function scan(root) {
  if (!(root instanceof Element) || !root.isConnected) return;
  load(root);
  for (const element of root.querySelectorAll(selector)) load(element);
}

const observer = new MutationObserver((records) => {
  // A morph may report the same nested subtree more than once in one batch.
  const roots = new Set();
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element && node.isConnected) roots.add(node);
    }
  }
  for (const root of roots) {
    let parent = root.parentElement;
    while (parent && !roots.has(parent)) parent = parent.parentElement;
    if (!parent) scan(root);
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true });
scan(document.documentElement);
